<template>
  <div class="font-modify">
    <b-modal
      id="modal-edit-patient-card"
      :no-close-on-backdrop="true"
      ok-only
      centered
      size="lg"
      :title="$t('reception.edit-patient-card')"
      @ok="EditPatientCard()"
    >
      <b-card-text>
        <b-row>
          <b-col md="6">
            <b-form-group
              :label="$t('reception.companion-name')"
              label-for="Name"
            >
              <b-form-input
                id="Name"
                v-model="EditForm.full_companion_name"
                :placeholder="$t('reception.enter-patient-name')"
              />
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group
              :label="$t('reception.companion-phone')"
              label-for="phoneNumber"
            >
              <VuePhoneNumberInput
                v-model="EditForm.companion_phone"
                default-country-code="IQ"
                :error="
                  EditForm.companion_phone
                    ? isNotValid || EditForm.companion_phone[0] != 0
                    : false
                "
                @update="
                  (obj) => {
                    showPhoneObj(obj, 'countryCallingCode');
                  }
                "
              />
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group
              :label="$t('reception.next-kin-name')"
              label-for="Name"
            >
              <b-form-input
                id="Name"
                v-model="EditForm.next_of_kin_name"
                :placeholder="$t('reception.next-kin-name')"
              />
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group
              :label="$t('reception.next-kin-phone')"
              label-for="phoneNumber"
            >
              <VuePhoneNumberInput
                v-model="EditForm.next_of_kin_phone_number"
                default-country-code="IQ"
                :error="
                  EditForm.next_of_kin_phone_number
                    ? isNotValid || EditForm.next_of_kin_phone_number[0] != 0
                    : false
                "
                @update="
                  (obj) => {
                    showPhoneObj(obj, 'countryCallingCode');
                  }
                "
              />
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group
              :label="$t('reception.patient-case')"
              label-for="Case"
            >
              <b-form-input
                id="Case"
                v-model="EditForm.patient_case"
                :placeholder="$t('reception.enter-patient-case')"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              :label="$t('reception.diagnosis')"
              label-for="diagnosis"
            >
              <b-form-textarea
                id="diagnosis"
                v-model="EditForm.diagnosis"
                :placeholder="$t('reception.diagnosis')"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              :label="$t('reception.investigation')"
              label-for="investigation"
            >
              <b-form-textarea
                id="investigation"
                v-model="EditForm.investigation"
                :placeholder="$t('reception.investigation')"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              :label="$t('reception.examination')"
              label-for="examination"
            >
              <b-form-textarea
                id="examination"
                v-model="EditForm.examination"
                :placeholder="$t('reception.examination')"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              :label="$t('reception.treatment')"
              label-for="treatment"
            >
              <b-form-textarea
                id="treatment"
                v-model="EditForm.treatment"
                :placeholder="$t('reception.treatment')"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              :label="$t('reception.allergy')"
              label-for="allergy"
            >
              <b-form-textarea
                id="allergy"
                v-model="EditForm.allergy"
                :placeholder="$t('reception.allergy')"
              />
            </b-form-group>
          </b-col>

          <b-col
            md="6"
            cols="12"
          >
            <b-form-group
              :label="$t('reception.weight')"
              label-for="weight"
            >
              <b-form-input
                id="weight"
                v-model="EditForm.weight"
                type="number"
                :placeholder="$t('reception.weight')"
              />
            </b-form-group>
          </b-col>

          <b-col
            md="6"
            cols="12"
          >
            <b-form-group
              :label="$t('reception.height')"
              label-for="height"
            >
              <b-form-input
                id="height"
                v-model="EditForm.height"
                type="number"
                :placeholder="$t('reception.height')"
              />
            </b-form-group>
          </b-col>

          <b-col
            md="3"
            cols="12"
          >
            <b-form-checkbox v-model="EditForm.is_smoker">
              {{ $t("reception.smoking") }}
            </b-form-checkbox>
          </b-col>
          <b-col
            md="3"
            cols="12"
          >
            <b-form-checkbox v-model="EditForm.has_high_blood_pressure">
              {{ $t("reception.has-high-blood-pressure") }}
            </b-form-checkbox>
          </b-col>
          <b-col
            md="3"
            cols="12"
          >
            <b-form-checkbox v-model="EditForm.has_diabetes">
              {{ $t("reception.diabetic") }}
            </b-form-checkbox>
          </b-col>
          <b-col
            md="3"
            cols="12"
          >
            <b-form-checkbox v-model="EditForm.has_heart_disease">
              {{ $t("reception.has-heart-disease") }}
            </b-form-checkbox>
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>
    <!--
   ???????? use this to disable the button for non-admin users !!!!!!!!!

    :disabled="
                !$store.state.auth.permissions.includes(
                  'assign-permission-to-user'
                )
              " -->
    <b-modal
      id="modal-exit-room"
      :no-close-on-backdrop="true"
      ok-only
      centered
      size="lg"
      :title="$t('reception.pationt-out-room')"
      @ok="patientExitRoom()"
    >
      <b-card-text>
        <h2>{{ $t("reception.pationt-out-room-conferm") }}</h2>
      </b-card-text>
    </b-modal>
    <!-- Quick Add Modals -->
    <b-modal
      id="modal-add-lab-test"
      :no-close-on-backdrop="true"
      ok-only
      centered
      size="lg"
      :title="$t('reception.add-lab-test')"
      :ok-disabled="!canSubmitLab"
      @ok="submitLab"
    >
      <b-card-text>
        <b-row>
          <b-col
            md="6"
            cols="12"
          >
            <AutoComplete
              v-model="labCreate.singleTests"
              :label="$t('lab.test')"
              :placeholder="$t('lab.test')"
              :multiple="true"
              param-query="search"
              :serializer="labTestSerializer"
              endpoint="test"
              :close-on-select="false"
              text-title="name"
              @input="addTestsToList"
            />
          </b-col>
          <b-col
            md="6"
            cols="12"
          >
            <AutoComplete
              v-model="labCreate.group"
              :label="$t('lab.test-group')"
              :placeholder="$t('lab.test-group')"
              param-query="search"
              :serializer="(val) => val.id"
              endpoint="group"
              text-title="name"
              @input="selectGroup"
            />
          </b-col>
          <b-col md="6">
            <b-form-group
              :label="$t('lab.sample-id')"
              label-for="sample-id"
              label-class="font-weight-bold"
            >
              <b-form-input
                id="sample-id"
                v-model="labCreate.sampleId"
                :placeholder="$t('lab.enter-sample-id')"
                trim
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              :label="$t('lab.sample-date')"
              label-for="sample-date"
              label-class="font-weight-bold"
            >
              <b-form-datepicker
                id="sample-date"
                v-model="labCreate.sampleDate"
                :max="new Date().toISOString().slice(0, 10)"
                :placeholder="$t('lab.select-date')"
                today-button
                reset-button
                close-button
                class="mb-2"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <!-- Selected Tests Section -->
        <div class="selected-tests-section mt-3">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <h5 class="mb-0">
              {{ $t("lab.test") }}
            </h5>
            <b-button
              v-if="labTestListFiltered.length > 0"
              size="sm"
              variant="outline-danger"
              @click="clearAllTests"
            >
              <i class="fas fa-trash-alt mr-1" />
              {{ $t("lab.clear-all") }}
            </b-button>
          </div>
          <div class="selected-tests-container">
            <div
              v-if="!labTestListFiltered.length"
              class="text-center py-4"
            >
              <i
                class="fas fa-vial text-muted mb-2"
                style="font-size: 2rem"
              />
              <p class="text-muted mb-0">
                {{ $t("lab.no-tests-selected-message") }}
              </p>
            </div>
            <b-table
              v-else
              :items="labTestListFiltered"
              :fields="labTestColumns"
              striped
              hover
              responsive
              show-empty
              :empty-text="$t('lab.no-tests-selected')"
              class="mb-0"
              thead-class="bg-light"
            >
              <template #cell(name)="data">
                <span class="font-weight-medium">{{ data.item.name }}</span>
              </template>
              <template #cell(price)="data">
                <b-badge
                  variant="light"
                  class="text-dark"
                >
                  {{ formatPrice(data.item.price) }}
                </b-badge>
              </template>
            </b-table>
          </div>
          <!-- Summary Section -->
          <div
            v-if="labTestListFiltered.length > 0"
            class="d-flex justify-content-between mt-2 p-2 bg-light rounded"
          >
            <span
              class="font-weight-bold"
            >{{ $t("lab.total-tests") }}:
              {{ labTestListFiltered.length }}</span>
            <span
              class="font-weight-bold"
            >{{ $t("lab.total-price") }}:
              {{ formatPrice(labTotalPrice) }}</span>
          </div>
        </div>
      </b-card-text>
    </b-modal>
    <b-modal
      id="modal-add-drug"
      :no-close-on-backdrop="true"
      ok-only
      centered
      size="lg"
      :title="$t('reception.add-drug')"
      :ok-disabled="!canSubmitDrug"
      @ok="submitDrug"
    >
      <b-card-text>
        <b-row>
          <b-col md="6">
            <b-form-group :label="$t('office.source_of_drug')">
              <v-select
                v-model="drugCreate.source_of_drug"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="[
                  { label: 'Hospital', value: 'hospital' },
                  { label: 'Pharmacy', value: 'pharmacy' },
                  { label: 'External', value: 'external' },
                ]"
                :reduce="(option) => option.value"
                :placeholder="$t('office.source_of_drug')"
                @input="handleDrugSourceChange"
              />
            </b-form-group>
          </b-col>
          <b-col
            v-if="
              drugCreate.source_of_drug !== 'external' &&
                drugCreate.source_of_drug === 'pharmacy'
            "
            md="6"
          >
            <AutoComplete
              v-model="drugCreate.drug_scientific_name_id"
              :label="$t('common.drug_scientific_name')"
              :placeholder="$t('common.drug_scientific_name')"
              :serializer="(val) => val.id"
              endpoint="drugScientificName"
              text-title="name"
            />
            <AutoComplete
              v-model="drugCreate.item_id"
              :disabled="!drugCreate.source_of_drug"
              :label="$t('office.item_name')"
              :placeholder="$t('office.item_name')"
              :serializer="(val) => val.id"
              endpoint="item"
              text-title="name"
              :other-query="`filter[type]=${drugCreate.source_of_drug}&filter[drug_scientific_name_id]=${drugCreate.drug_scientific_name_id}`"
            />
          </b-col>
          <b-col
            v-if="
              drugCreate.source_of_drug !== 'external' &&
                drugCreate.source_of_drug === 'hospital'
            "
            md="6"
          >
            <AutoComplete
              v-model="drugCreate.item_id"
              :disabled="!drugCreate.source_of_drug"
              :label="$t('office.item_name')"
              :placeholder="$t('office.item_name')"
              :serializer="(val) => val.id"
              endpoint="item"
              text-title="name"
              :other-query="`filter[type]=${drugCreate.source_of_drug}`"
            />
          </b-col>
          <b-col
            v-if="drugCreate.source_of_drug === 'external'"
            md="6"
          >
            <b-form-group :label="$t('office.item_name_external')">
              <b-form-input
                v-model="drugCreate.item_name"
                :placeholder="$t('office.item_name_external')"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group :label="$t('office.number_of_doses')">
              <b-form-input
                v-model="drugCreate.number_of_doses"
                type="number"
                :placeholder="$t('office.number_of_doses')"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group :label="$t('office.duration_between_doses')">
              <b-form-input
                v-model="drugCreate.duration_between_doses"
                :placeholder="$t('office.duration_between_doses')"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group :label="$t('office.type')">
              <b-form-input
                v-model="drugCreate.type"
                :placeholder="$t('office.type')"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group :label="$t('office.dose')">
              <b-form-input
                v-model="drugCreate.dose"
                :placeholder="$t('office.dose')"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group :label="$t('office.start_time')">
              <datetime
                v-model="drugCreate.start_time"
                input-class="form-control"
                type="datetime"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group :label="$t('office.description')">
              <b-form-textarea
                v-model="drugCreate.description"
                :placeholder="$t('office.description')"
                rows="3"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>
    <b-modal
      id="modal-add-radiology"
      :no-close-on-backdrop="true"
      ok-only
      centered
      size="lg"
      :title="$t('reception.add-radiology')"
      :ok-disabled="!canSubmitRadiology"
      @ok="submitRadiology"
    >
      <b-card-text>
        <b-row>
          <b-col md="6">
            <AutoComplete
              v-model="radiologyCreate.radiology_id"
              :label="$t('radiology.radiology')"
              :placeholder="$t('radiology.radiology')"
              param-query="search"
              :serializer="(val) => val.id"
              endpoint="radiology"
              text-title="name"
            />
          </b-col>
          <b-col md="6">
            <b-form-group
              :label="$t('common.url')"
              label-for="url"
            >
              <b-form-input
                id="url"
                v-model="radiologyCreate.url"
                :placeholder="$t('common.url')"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>
    <b-modal
      id="modal-add-consultation"
      :no-close-on-backdrop="true"
      ok-only
      centered
      size="lg"
      :title="$t('reception.add-consultation')"
      :ok-disabled="!canSubmitConsultation"
      @ok="submitConsultation"
    >
      <b-card-text>
        <b-row>
          <b-col md="6">
            <AutoComplete
              v-model="consultationCreate.doctor_id"
              :label="$t('surgery.Doctor')"
              :placeholder="$t('surgery.Doctor')"
              param-query="search"
              :serializer="(val) => val.id"
              endpoint="doctor"
              text-title="name"
            />
          </b-col>
          <b-col md="6">
            <b-form-group
              :label="$t('reception.doctor-price')"
              label-for="doctor-price"
            >
              <b-form-input
                id="doctor-price"
                v-model="consultationCreate.doctor_price"
                type="number"
                :placeholder="$t('reception.doctor-price')"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>
    <b-modal
      id="modal-add-scanned-attachments"
      :no-close-on-backdrop="true"
      centered
      size="xl"
      :title="$t('reception.add-scanned-attachments')"
      hide-footer
    >
      <ScannedAttachments
        v-if="patientCardData.type == 'CLINIC'"
        :patient-card-id="getNestedProperty(patientCardData, 'id')"
      />
    </b-modal>
    <b-modal
      id="modal-add-attachments"
      :no-close-on-backdrop="true"
      centered
      size="xl"
      :title="$t('reception.add-attachments')"
      hide-footer
    >
      <Attachments
        :patient-card-id="getNestedProperty(patientCardData, 'id')"
      />
    </b-modal>
    <b-modal
      id="modal-add-to-room"
      :no-close-on-backdrop="true"
      ok-only
      centered
      size="lg"
      :title="$t('reception.pationt-add-to-room')"
      @ok="addNewRoomToPatient()"
    >
      <b-card-text>
        <b-row>
          <b-col cols="12">
            <AutoComplete
              v-model="patientRoom.room"
              :label="$t('reception.room')"
              :placeholder="$t('reception.room')"
              param-query="search"
              :serializer="(val) => val"
              no-sort
              endpoint="available-room"
              text-title="name"
            />
          </b-col>
          <b-col cols="12">
            <b-form-group :label="$t('reception.day')">
              <b-form-input
                v-model="patientRoom.day"
                :placeholder="$t('reception.day')"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>

    <b-modal
      id="modal-change-patient-card-type"
      :no-close-on-backdrop="true"
      ok-only
      centered
      size="lg"
      :title="$t('reception.change-patient-card-type')"
      @ok="ChangePatientCardType()"
    >
      <b-card-text>
        <b-row>
          <b-col md="12">
            <b-form-group
              :label="$t('reception.patient-type')"
              label-for="Type"
            >
              <v-select
                v-model="patientCardTypeData.type"
                :options="['IN', 'OUT', 'EMERGENCY', 'CLINIC', 'LAB', 'NICU']"
                :placeholder="$t('reception.patient-type')"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>

    <template v-if="loading">
      <div>
        <div class="d-flex justify-content-center mb-1">
          <b-spinner :label="$t('common.loading')" />
        </div>
      </div>
    </template>
    <b-row v-else>
      <b-col
        cols="12"
        sm="12"
      >
        <b-card class="patient-card-modern">
          <!-- Header with Back Button and Actions -->
          <div class="card-header-actions mb-1">
            <div class="d-flex align-items-center">
              <b-button
                variant="outline-secondary"
                size="sm"
                class="back-btn mr-3"
                @click="$router.go(-1)"
              >
                <i class="fas fa-arrow-left mr-1" />
                {{ $t("common.go-back") }}
              </b-button>
            </div>
            <div class="action-buttons">
              <!-- Quick Actions -->
              <b-button
                v-if="permissions.includes('get-patientCardTest')"
                variant="primary"
                size="sm"
                :disabled="!is_active"
                @click="$bvModal.show('modal-add-lab-test')"
              >
                <i class="fas fa-vials" />
                {{ $t("reception.add-lab-test") }}
              </b-button>
              <b-button
                variant="primary"
                size="sm"
                :disabled="!is_active"
                @click="$bvModal.show('modal-add-drug')"
              >
                <i class="fas fa-prescription-bottle-alt" />
                {{ $t("reception.add-drug") }}
              </b-button>
              <b-button
                v-if="permissions.includes('get-patientCardRadiology')"
                variant="primary"
                size="sm"
                :disabled="!is_active"
                @click="$bvModal.show('modal-add-radiology')"
              >
                <i class="fas fa-x-ray" />
                {{ $t("reception.add-radiology") }}
              </b-button>
              <!-- <b-button
                variant="primary"
                size="sm"
                :disabled="!is_active"
                @click="$bvModal.show('modal-add-consultation')"
              >
                <i class="fas fa-user-md" />
                {{ $t("reception.add-consultation") }}
              </b-button> -->
              <b-button
                v-if="patientCardData.type == 'CLINIC'"
                variant="primary"
                size="sm"
                :disabled="!is_active"
                @click="$bvModal.show('modal-add-scanned-attachments')"
              >
                <i class="fas fa-scanner" />
                {{ $t("reception.scan-attachments") }}
              </b-button>
              <b-button
                variant="primary"
                size="sm"
                :disabled="!is_active"
                @click="$bvModal.show('modal-add-attachments')"
              >
                <i class="fas fa-paperclip" />
                {{ $t("reception.add-attachments") }}
              </b-button>

              <b-button
                v-if="permissions.includes('update-patientCard')"
                variant="warning"
                size="sm"
                :disabled="!is_active"
                @click="show(patientCardData)"
              >
                <i class="fas fa-edit" />
                {{ $t("reception.edit-patient-card") }}
              </b-button>
              <!-- <b-button
                v-if="
                  permissions.includes('update-patientCard')
                "
                variant="outline-warning"
                size="sm"
                :disabled="!is_active"
                @click="showCardTypeChange(patientCardData)"
              >
                <i class="fas fa-sync-alt" />
                {{ $t("reception.change-patient-card-type") }}
              </b-button> -->
              <b-button
                v-if="
                  permissions.includes('update-patientRoom') &&
                    hasActiveRoom() &&
                    patientCardData.type == 'IN'
                "
                variant="outline-danger"
                size="sm"
                :disabled="!is_active"
                @click="showExitRoomModel()"
              >
                <i class="fas fa-sign-out-alt" />
                {{ $t("reception.pationt-out-room") }}
              </b-button>
              <b-button
                v-if="
                  permissions.includes('update-patientRoom') &&
                    !hasActiveRoom() &&
                    patientCardData.type == 'IN'
                "
                variant="success"
                size="sm"
                :disabled="!is_active"
                @click="showAddRoomModel()"
              >
                <i class="fas fa-procedures" />
                {{ $t("reception.pationt-add-to-room") }}
              </b-button>
              <b-dropdown
                variant="success"
                size="sm"
                text="Print"
                right
              >
                <template #button-content>
                  <feather-icon
                    icon="PrinterIcon"
                    size="14"
                    class="mr-1"
                  />
                  {{ $t("common.print") }}
                </template>
                <template v-if="patientSurgeries.length > 0">
                  <b-dropdown-item @click="printOperativeNotes()">
                    <feather-icon
                      icon="FileTextIcon"
                      size="14"
                      class="mr-1"
                    />
                    {{ $t("surgery.print-operative-notes") }}
                  </b-dropdown-item>
                  <b-dropdown-item @click="openAgreementPrintModal()">
                    <feather-icon
                      icon="FileIcon"
                      size="14"
                      class="mr-1"
                    />
                    {{ $t("reception.print-agreement") }}
                  </b-dropdown-item>
                  <b-dropdown-item @click="printDischargeAgainstAdvice()">
                    <feather-icon
                      icon="FileTextIcon"
                      size="14"
                      class="mr-1"
                    />
                    {{ $t("surgery.print-discharge-against-advice") }}
                  </b-dropdown-item>
                </template>
                <template v-if="patientCardData.type === 'NICU'">
                  <b-dropdown-item @click="printBirthCertificateCommitment()">
                    <feather-icon
                      icon="FileTextIcon"
                      size="14"
                      class="mr-1"
                    />
                    {{ $t("incubator.print-birth-certificate-commitment") }}
                  </b-dropdown-item>
                  <b-dropdown-item @click="printNICUDischargeAgainstAdvice()">
                    <feather-icon
                      icon="FileTextIcon"
                      size="14"
                      class="mr-1"
                    />
                    {{ $t("incubator.print-discharge-against-advice") }}
                  </b-dropdown-item>
                </template>
                <b-dropdown-item @click="printPatientAccountStatement()">
                  <feather-icon
                    icon="FileTextIcon"
                    size="14"
                    class="mr-1"
                  />
                  كشف حساب المريض
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
          <h3 class="card-title mb-2">
            <i class="fas fa-file-medical text-primary" />
            {{ $t("reception.patient-card-detalis") }}
            <b-badge
              v-if="isPatientDischarged"
              variant="danger"
              class="ml-2"
            >
              {{ $t("common.discharged") }}
            </b-badge>
          </h3>
          <!-- Patient Identity -->
          <div class="patient-identity mb-3">
            <i class="fas fa-user-injured fa-2x text-primary" />
            <div class="identity-info">
              <h4 class="patient-name mb-0">
                {{ getNestedProperty(patientCardData, "patient.name") }}
              </h4>
              <div class="d-flex align-items-center mt-1">
                <b-badge
                  variant="info"
                  class="mr-2"
                >
                  <i class="fas fa-id-card-alt mr-1" />
                  {{ getNestedProperty(patientCardData, "type") }}
                </b-badge>
                <span class="text-muted">
                  <i class="fas fa-hospital-user mr-1" />
                  {{ roomName }}
                </span>
              </div>
            </div>
          </div>

          <hr class="divider">

          <!-- Contact Information -->
          <div class="info-section">
            <h5 class="section-title">
              <i class="fas fa-address-book" />
              {{ $t("reception.contact-information") }}
            </h5>
            <div class="info-grid">
              <div class="info-item">
                <i class="fas fa-user-friends text-info" />
                <div>
                  <span class="label">{{
                    $t("reception.companion-name")
                  }}</span>
                  <strong class="value">{{
                    getNestedProperty(patientCardData, "full_companion_name")
                  }}</strong>
                </div>
              </div>
              <div class="info-item">
                <i class="fas fa-phone-alt text-info" />
                <div>
                  <span class="label">{{
                    $t("reception.companion-phone")
                  }}</span>
                  <strong class="value">{{
                    getNestedProperty(patientCardData, "companion_phone")
                  }}</strong>
                </div>
              </div>
              <div class="info-item">
                <i class="fas fa-user-shield text-info" />
                <div>
                  <span class="label">{{ $t("reception.next-kin-name") }}</span>
                  <strong class="value">{{
                    getNestedProperty(patientCardData, "next_of_kin_name")
                  }}</strong>
                </div>
              </div>
              <div class="info-item">
                <i class="fas fa-phone-square text-info" />
                <div>
                  <span class="label">{{
                    $t("reception.next-kin-phone")
                  }}</span>
                  <strong class="value">{{
                    getNestedProperty(
                      patientCardData,
                      "next_of_kin_phone_number"
                    )
                  }}</strong>
                </div>
              </div>
            </div>
          </div>

          <hr class="divider">

          <!-- Medical Conditions -->
          <div class="info-section">
            <h5 class="section-title">
              <i class="fas fa-heartbeat" />
              {{ $t("reception.medical-information") }}
            </h5>
            <div class="medical-grid">
              <div
                class="medical-badge"
                :class="
                  getNestedProperty(patientCardData, 'allergy')
                    ? 'has-condition danger'
                    : ''
                "
              >
                <i class="fas fa-allergies" />
                <span class="condition-label">{{
                  $t("reception.allergy")
                }}</span>
                <strong class="condition-value">{{
                  getNestedProperty(patientCardData, "allergy") || "-"
                }}</strong>
              </div>
              <div
                class="medical-badge"
                :class="
                  getNestedProperty(patientCardData, 'has_diabetes')
                    ? 'has-condition warning'
                    : ''
                "
              >
                <i class="fas fa-syringe" />
                <span class="condition-label">{{
                  $t("reception.diabetic")
                }}</span>
                <strong class="condition-value">{{
                  getNestedProperty(patientCardData, "has_diabetes")
                    ? "Yes"
                    : "No"
                }}</strong>
              </div>
              <div
                class="medical-badge"
                :class="
                  getNestedProperty(patientCardData, 'has_heart_disease')
                    ? 'has-condition danger'
                    : ''
                "
              >
                <i class="fas fa-heart" />
                <span class="condition-label">{{
                  $t("reception.heart-disease")
                }}</span>
                <strong class="condition-value">{{
                  getNestedProperty(patientCardData, "has_heart_disease")
                    ? "Yes"
                    : "No"
                }}</strong>
              </div>
              <div
                class="medical-badge"
                :class="
                  getNestedProperty(patientCardData, 'has_high_blood_pressure')
                    ? 'has-condition danger'
                    : ''
                "
              >
                <i class="fas fa-tachometer-alt" />
                <span class="condition-label">{{
                  $t("reception.hypertension")
                }}</span>
                <strong class="condition-value">{{
                  getNestedProperty(patientCardData, "has_high_blood_pressure")
                    ? "Yes"
                    : "No"
                }}</strong>
              </div>
              <div
                class="medical-badge"
                :class="
                  getNestedProperty(patientCardData, 'is_smoker')
                    ? 'has-condition secondary'
                    : ''
                "
              >
                <i class="fas fa-smoking" />
                <span class="condition-label">{{
                  $t("reception.smoking")
                }}</span>
                <strong class="condition-value">{{
                  getNestedProperty(patientCardData, "is_smoker") ? "Yes" : "No"
                }}</strong>
              </div>
              <div class="medical-badge">
                <i class="fas fa-weight" />
                <span class="condition-label">{{
                  $t("reception.weight")
                }}</span>
                <strong class="condition-value">{{
                  getNestedProperty(patientCardData, "weight") || "-"
                }}</strong>
              </div>
              <div class="medical-badge">
                <i class="fas fa-ruler-vertical" />
                <span class="condition-label">{{
                  $t("reception.height")
                }}</span>
                <strong class="condition-value">{{
                  getNestedProperty(patientCardData, "height") || "-"
                }}</strong>
              </div>
            </div>
          </div>

          <hr class="divider">

          <!-- Clinical Details -->
          <div class="info-section">
            <h5 class="section-title">
              <i class="fas fa-stethoscope" />
              {{ $t("reception.clinical-information") }}
            </h5>
            <div class="clinical-grid">
              <div class="clinical-item">
                <div class="clinical-header">
                  <i class="fas fa-notes-medical text-danger" />
                  <span>{{ $t("reception.patient-case") }}</span>
                </div>
                <p class="clinical-text">
                  {{
                    getNestedProperty(patientCardData, "patient_case") || "-"
                  }}
                </p>
              </div>
              <div class="clinical-item">
                <div class="clinical-header">
                  <i class="fas fa-diagnoses text-warning" />
                  <span>{{ $t("reception.diagnosis") }}</span>
                </div>
                <p class="clinical-text">
                  {{ getNestedProperty(patientCardData, "diagnosis") || "-" }}
                </p>
              </div>
              <div class="clinical-item">
                <div class="clinical-header">
                  <i class="fas fa-microscope text-info" />
                  <span>{{ $t("reception.investigation") }}</span>
                </div>
                <p class="clinical-text">
                  {{
                    getNestedProperty(patientCardData, "investigation") || "-"
                  }}
                </p>
              </div>
              <div class="clinical-item">
                <div class="clinical-header">
                  <i class="fas fa-user-md text-success" />
                  <span>{{ $t("reception.examination") }}</span>
                </div>
                <p class="clinical-text">
                  {{ getNestedProperty(patientCardData, "examination") || "-" }}
                </p>
              </div>
              <div class="clinical-item full-width">
                <div class="clinical-header">
                  <i class="fas fa-pills text-primary" />
                  <span>{{ $t("reception.treatment") }}</span>
                </div>
                <p class="clinical-text">
                  {{ getNestedProperty(patientCardData, "treatment") || "-" }}
                </p>
              </div>
            </div>
          </div>

          <hr class="divider">

          <!-- Timeline -->
          <div class="info-section">
            <h5 class="section-title">
              <i class="fas fa-clock" />
              {{ $t("reception.patient-updates") }}
            </h5>
            <div class="timeline-grid">
              <div class="timeline-item">
                <i class="fas fa-calendar-plus text-success" />
                <div>
                  <span class="label">{{
                    $t("reception.patient-info-created-at")
                  }}</span>
                  <strong class="value">{{
                    getNestedProperty(patientCardData, "created_at")
                  }}</strong>
                </div>
              </div>
              <div class="timeline-item">
                <i class="fas fa-calendar-check text-warning" />
                <div>
                  <span class="label">{{
                    $t("reception.date-of-last-update")
                  }}</span>
                  <strong class="value">{{
                    getNestedProperty(patientCardData, "updated_at")
                  }}</strong>
                </div>
              </div>
            </div>
          </div>
        </b-card>

        <b-card
          class="mb-2"
          style="padding: 0"
        >
          <PateintCardTest
            v-if="permissions.includes('get-patientCardTest')"
            ref="patientCardTest"
            :patient-card-id2="$route.params.card_id"
            :patient-card-id="$route.params.card_id"
            :disabled="!is_active"
            show-name="false"
            :hide-add-button="true"
          />
        </b-card>

        <!-- Invoices Section -->
      </b-col>
    </b-row>
    <!-- <PatentCardSurgery
      :patientCardId="patientCardData.id"
      :patientSurgery="patientCardData.surgeries[0]"
      :doctors="patientCardData.doctors"
      v-if="
        patientCardData.type == 'IN' &&
        (permissions.includes('get-patientCardSurgery') ||
          permissions.includes('store-patientCardSurgery'))
      "
    /> -->
    <!-- <PatientEmergency
      v-if="patientCardData.type == 'EMERGENCY'"
      :patient-card-id="getNestedProperty(patientCardData, 'id')"
      :disabled="!is_active"
    /> -->
    <b-card
      class="mb-2"
      style="padding: 0"
    >
      <PatientDrug
        ref="patientDrug"
        :patient-card-id="getNestedProperty(patientCardData, 'id')"
        :disabled="!is_active"
        :hide-add-button="true"
      />
    </b-card>
    <div
      class="mb-2"
      style="padding: 0"
    >
      <PatientCardRadiology
        v-if="permissions.includes('get-patientCardRadiology')"
        ref="patientCardRadiology"
        :patient-card-id="getNestedProperty(patientCardData, 'id')"
        :disabled="!is_active"
        :hide-add-button="true"
      />
    </div>

    <b-card
      v-if="patientCardData.type == 'CLINIC'"
      class="mb-2"
      style="padding: 0"
    >
      <ScannedAttachments
        :patient-card-id="getNestedProperty(patientCardData, 'id')"
      />
    </b-card>
    <!-- <PatientOutClinicInvoice
      :patientCardId="patientCardData.id"
      v-if="
          patientCardData.type == 'OUT') ||
        patientCardData.type == 'EMERGENCY' ||
        patientCardData.type == 'CLINIC'
      "
    /> -->

    <!-- <SurgeryInsuranceInvoice
      :patientCardId="patientCardData.id"
      v-if="
        permissions.includes('get-invoiceInsuranceSurgery') &&
        patientCardData.type == 'IN'
      "
    /> -->
    <div class="mb-2 pa-0">
      <Attachments
        ref="attachments"
        :patient-card-id="getNestedProperty(patientCardData, 'id')"
      />
    </div>

    <div
      v-if="permissions.includes('get-invoice')"
      class="invoices-section"
    >
      <div class="section-header">
        <div class="section-title">
          <i class="fas fa-file-invoice" />
          <h3>{{ $t("incubator.invoices") }}</h3>
          <span class="count-badge">{{ invoices.length }}</span>
        </div>
      </div>

      <div
        v-if="invoices && invoices.length"
        class="invoices-grid"
      >
        <div
          v-for="invoice in invoices"
          :key="invoice.id"
          class="invoice-card"
        >
          <div class="invoice-header">
            <div class="invoice-number">
              #{{ invoice.invoice_no }}
            </div>
            <div class="invoice-status-wrapper">
              <ChangeInvoiceStatusDropDown
                name="activePatientCardInvoice"
                endpoint="invoices"
                :data="invoice"
                @onEmit="fetchInvoices"
              />
            </div>
          </div>
          <div class="invoice-amount">
            {{ formatPrice(invoice.amount) }}
          </div>
          <div
            v-if="invoice.description"
            class="invoice-description"
          >
            {{ invoice.description }}
          </div>
          <div class="invoice-footer">
            <div class="invoice-date">
              <feather-icon
                icon="CalendarIcon"
                size="14"
              />
              <span>{{ invoice.date }}</span>
            </div>
            <div class="invoice-type">
              <feather-icon
                icon="TagIcon"
                size="14"
              />
              <span>{{ getInvoiceTypeName(invoice.type) }}</span>
            </div>
          </div>
          <div class="invoice-actions">
            <b-button
              v-if="
                invoice.status !== 'printed' && invoice.status === 'approved'
              "
              variant="primary"
              size="sm"
              @click="showInvoicePrint(invoice)"
            >
              <feather-icon
                icon="PrinterIcon"
                size="14"
              />
              {{ $t("reception.Print Invoice") }}
            </b-button>
          </div>
        </div>
      </div>
      <div
        v-else
        class="no-invoices"
      >
        <i
          class="fas fa-file-invoice"
          style="font-size: 3rem"
        />
        <p>{{ $t("common.no-invoices-yet") }}</p>
      </div>
    </div>

    <!-- Print Modal Confirmation -->
    <b-modal
      v-for="item in invoices"
      :id="`modal-confirm-print-${item.id}`"
      :key="`print-modal-${item.id}`"
      :no-close-on-backdrop="true"
      :title="$t('reception.print-invoice')"
      ok-only
      :ok-title="$t('common.print')"
      @ok="handlePrintOk"
      @hide="handlePrintHide"
    >
      <b-card-text>
        <h5>{{ $t("reception.print-invoice") }}</h5>
        {{ $t("surgery.print-sure") }}
      </b-card-text>
    </b-modal>

    <!-- Print Invoice Components -->
    <!-- NICU Invoice -->
    <NICUInvoice
      v-if="
        currentInvoiceForPrint && currentInvoiceForPrint.type === 'invoice_nicu'
      "
      :patient-data="patientDataForPrint || patientCardData"
      :data="currentInvoiceForPrint"
      :incubator-name="incubatorNameForPrint"
    />

    <!-- Out Clinic Invoice -->
    <OutClinicInvoice
      v-if="
        currentInvoiceForPrint &&
          currentInvoiceForPrint.type === 'invoice_out_clinic'
      "
      :patient-data="patientDataForPrint || patientCardData"
      :data="currentInvoiceForPrint"
    />

    <!-- Emergency Invoice -->
    <EmergencyInvoice
      v-if="
        currentInvoiceForPrint &&
          currentInvoiceForPrint.type === 'invoice_emergency'
      "
      :patient-data="patientDataForPrint || patientCardData"
      :data="currentInvoiceForPrint"
    />

    <!-- Test Invoice -->
    <TestInvoice
      v-if="
        currentInvoiceForPrint &&
          currentInvoiceForPrint.type === 'invoice_patient_card_test'
      "
      :patient-data="getPatientDataForTestInvoice()"
      :data="currentInvoiceForPrint"
    />

    <!-- Refund Invoice -->
    <RefundInvoice
      v-if="currentInvoiceForPrint && currentInvoiceForPrint.type === 'refund'"
      :patient-data="patientDataForPrint || patientCardData"
      :data="currentInvoiceForPrint"
    />

    <!-- Surgery Insurance Invoice -->
    <SurgeryInsuranceInvoicePrint
      v-if="
        currentInvoiceForPrint &&
          currentInvoiceForPrint.type === 'invoice_insurance_surgery'
      "
      :patient-data="patientDataForPrint || patientCardData"
      :data="currentInvoiceForPrint"
    />

    <!-- Patient Account Statement -->
    <PatientAccountStatement
      v-if="showPatientAccountStatement"
      ref="patientAccountStatement"
      :data="pendingInvoicesData"
      :patient-name="getNestedProperty(patientCardData, 'patient.name')"
      :total-amount="pendingInvoicesTotal"
      @print-closed="showPatientAccountStatement = false"
    />

    <!-- NICU Print Components -->
    <!-- Birth Certificate Commitment Print Component -->
    <div
      v-if="patientCardData.type === 'NICU' && patientCardData.id"
      id="birth-certificate-commitment-print"
      class="print-only"
    >
      <BirthCertificateCommitmentPrint
        ref="birthCertificateCommitmentPrintRef"
        :patient-data="patientCardData"
      />
    </div>

    <!-- NICU Discharge Against Advice Print Component -->
    <div
      v-if="patientCardData.type === 'NICU' && patientCardData.id"
      id="nicu-discharge-against-advice-print"
      class="print-only"
    >
      <NICUDischargeAgainstAdvicePrint
        ref="nicuDischargeAgainstAdvicePrintRef"
        :patient-data="patientCardData"
      />
    </div>

    <!-- Hidden print buttons for invoices -->
    <b-button
      v-if="
        currentInvoiceForPrint && currentInvoiceForPrint.type === 'invoice_nicu'
      "
      ref="NICUInvoiceRef"
      v-print="NICUInvoiceConfig"
      variant="outline-primary"
      size="sm"
      class="hidden"
    >
      {{ $t("reception.Print Invoice") }}
    </b-button>

    <b-button
      v-if="
        currentInvoiceForPrint &&
          currentInvoiceForPrint.type === 'invoice_out_clinic'
      "
      ref="OutClinicInvoiceRef"
      v-print="OutClinicInvoiceConfig"
      variant="outline-primary"
      size="sm"
      class="hidden"
    >
      {{ $t("reception.Print Invoice") }}
    </b-button>

    <b-button
      v-if="
        currentInvoiceForPrint &&
          currentInvoiceForPrint.type === 'invoice_emergency'
      "
      ref="EmergencyInvoiceRef"
      v-print="EmergencyInvoiceConfig"
      variant="outline-primary"
      size="sm"
      class="hidden"
    >
      {{ $t("reception.Print Invoice") }}
    </b-button>

    <b-button
      v-if="
        currentInvoiceForPrint &&
          currentInvoiceForPrint.type === 'invoice_patient_card_test'
      "
      ref="TestInvoiceRef"
      v-print="TestInvoiceConfig"
      variant="outline-primary"
      size="sm"
      class="hidden"
    >
      {{ $t("reception.Print Invoice") }}
    </b-button>

    <b-button
      v-if="currentInvoiceForPrint && currentInvoiceForPrint.type === 'refund'"
      ref="RefundInvoiceRef"
      v-print="RefundInvoiceConfig"
      variant="outline-primary"
      size="sm"
      class="hidden"
    >
      {{ $t("reception.Print Invoice") }}
    </b-button>

    <b-button
      v-if="
        currentInvoiceForPrint &&
          currentInvoiceForPrint.type === 'invoice_insurance_surgery'
      "
      ref="SurgeryInsuranceInvoiceRef"
      v-print="SurgeryInsuranceInvoiceConfig"
      variant="outline-primary"
      size="sm"
      class="hidden"
    >
      {{ $t("reception.Print Invoice") }}
    </b-button>

    <!-- Print Surgery Components -->
    <OperativeNotesPrint
      v-if="selectedSurgeryForPrint && selectedSurgeryForPrint.id"
      ref="operativeNotesPrint"
      :patient-surgery-data="selectedSurgeryForPrint"
    />
    <AgreementPrint
      v-if="selectedSurgeryForPrint && selectedSurgeryForPrint.id"
      ref="agreementPrint"
      :patient-surgery-data="selectedSurgeryForPrint"
      :surgery-name="agreementSurgeryName"
    />
    <PatientDischargeAgainstAdvicePrint
      v-if="selectedSurgeryForPrint && selectedSurgeryForPrint.id"
      ref="dischargeAgainstAdvicePrint"
      :patient-surgery-data="selectedSurgeryForPrint"
    />

    <!-- Agreement Print Modal -->
    <b-modal
      id="modal-agreement-print"
      :title="$t('reception.print-agreement')"
      ok-only
      centered
      size="lg"
      :no-close-on-backdrop="true"
    >
      <b-card-text>
        <b-row>
          <b-col
            md="12"
            cols="12"
            class="mt-3"
          >
            <b-form-group :label="$t('surgery.surgery')">
              <v-select
                v-model="selectedAgreementSurgery"
                :options="availableSurgeriesOptions"
                :placeholder="$t('surgery.choose-surgery')"
                label="title"
                :reduce="(option) => option.title"
                @input="agreementSurgeryName = $event"
              />
            </b-form-group>
          </b-col>
          <b-col
            md="12"
            cols="12"
            class="mt-2"
          >
            <b-form-group
              :label="
                $t('surgery.surgery') +
                  ' (' +
                  $t('common.or') +
                  ' ' +
                  $t('common.write') +
                  ')'
              "
            >
              <b-form-input
                v-model="agreementSurgeryName"
                :placeholder="$t('surgery.surgery')"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
      <template #modal-footer="{}">
        <b-button
          variant="primary"
          class="m-0"
          block
          @click="generateAgreement()"
        >
          {{ $t("common.print") }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import {
  BCard,
  BRow,
  BCol,
  BButton,
  BLink,
  BCardText,
  BFormGroup,
  BFormTextarea,
  BFormInput,
  BSpinner,
  BFormCheckbox,
  BBadge,
  BTable,
  BFormDatepicker,
  BDropdown,
  BDropdownItem,
  BModal,
} from 'bootstrap-vue'
import ReceptionHistoryCard from '@/components/reception/ReceptionHistoryCard'
import ReceptionPatientCardWithQR from '@/components/reception/ReceptionPatientCardWithQR'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import PateintCardTest from '@/views/lab/PatientCardTest.vue'
import PatentCardSurgery from '@/views/surgery/PatientSurgery.vue'
import PatientCardRadiology from '@/views/radiology/PatientCardRadiology.vue'
import PatientOutClinicInvoice from '@/views/Reception/PatientOutClinicInvoice.vue'
import SurgeryInsuranceInvoice from '@/views/surgery/SurgeryInsuranceInvoice.vue'
import PatientEmergency from '@/views/emergency/PatientEmergency.vue'
import PatientDrug from '@/views/pharmacy/PatientDrug.vue'
import Attachments from './Attachments.vue'
import ScannedAttachments from '@/views/Clinic/ScannedAttachments.vue'
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'
import VueHtml2pdf from 'vue-html2pdf'
import patient from '@/store/patient'
import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
import ChangeInvoiceStatusDropDown from '@/components/invoices/ChangeInvoiceStatusDropDown.vue'

const AutoComplete = () => import('@/components/common/AutoComplete.vue')
const NICUInvoice = () => import('@/components/printables/NICUInvoice.vue')
const OutClinicInvoice = () => import('@/components/printables/OutClinicInvoice.vue')
const EmergencyInvoice = () => import('@/components/printables/EmergencyInvoice.vue')
const TestInvoice = () => import('@/components/printables/TestInvoice.vue')
const RefundInvoice = () => import('@/components/printables/RefundInvoice.vue')
const SurgeryInsuranceInvoicePrint = () => import('@/components/printables/SurgeryInsuranceInvoice.vue')
const OperativeNotesPrint = () => import('@/components/printables/OperativeNotesPrint.vue')
const AgreementPrint = () => import('@/components/printables/AgreementPrint.vue')
const PatientDischargeAgainstAdvicePrint = () => import('@/components/printables/PatientDischargeAgainstAdvicePrint.vue')
const PatientAccountStatement = () => import('@/components/printables/PatientAccountStatement.vue')
const BirthCertificateCommitmentPrint = () => import('@/components/printables/BirthCertificateCommitmentPrint.vue')
const NICUDischargeAgainstAdvicePrint = () => import('@/components/printables/NICUDischargeAgainstAdvicePrint.vue')
const AdmissionNotePrint = () => import('@/components/printables/AdmissionNote.vue')

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormInput,
    BFormTextarea,
    BFormGroup,
    BSpinner,
    BCard,
    BCardText,
    Attachments,
    BButton,
    BFormCheckbox,
    BBadge,
    ReceptionHistoryCard,
    ReceptionPatientCardWithQR,
    AutoComplete,
    vSelect,
    ToastificationContent,
    PateintCardTest,
    PatentCardSurgery,
    PatientCardRadiology,
    PatientOutClinicInvoice,
    SurgeryInsuranceInvoice,
    PatientEmergency,
    VuePhoneNumberInput,
    PatientDrug,
    ScannedAttachments,
    VueHtml2pdf,
    BTable,
    BFormDatepicker,
    Datetime,
    NICUInvoice,
    OutClinicInvoice,
    EmergencyInvoice,
    TestInvoice,
    RefundInvoice,
    SurgeryInsuranceInvoicePrint,
    ChangeInvoiceStatusDropDown,
    BDropdown,
    BDropdownItem,
    BModal,
    OperativeNotesPrint,
    AgreementPrint,
    PatientDischargeAgainstAdvicePrint,
    PatientAccountStatement,
    BirthCertificateCommitmentPrint,
    NICUDischargeAgainstAdvicePrint,
    AdmissionNotePrint,
  },
  data() {
    return {
      loading: false,
      params: {
        form: {},
        path: '',
      },
      labCreate: {
        singleTests: [],
        group: null,
        sampleId: '',
        sampleDate: new Date().toISOString().slice(0, 10),
        lastSelectedGroupId: null,
        testsList: [],
      },
      labTestColumns: [
        { key: 'name', label: this.$t('lab.test-name') },
        { key: 'price', label: this.$t('common.price') },
      ],
      drugCreate: {
        item_id: null,
        item_name: '',
        number_of_doses: '',
        duration_between_doses: '',
        source_of_drug: '',
        type: '',
        dose: '',
        start_time: new Date().toISOString(),
        description: '',
        drug_scientific_name_id: null,
      },
      radiologyCreate: { radiology_id: null, type: '1', url: '' },
      consultationCreate: {
        doctor_id: null,
        doctor_price: '',
      },
      EditForm: {
        full_companion_name: '',
        next_of_kin_name: '',
        next_of_kin_phone_number: '',
        companion_phone: '',
        patient_case: '',
        diagnosis: '',
        investigation: '',
        treatment: '',
        examination: '',
        type: '',
        allergy: '',
        weight: '',
        height: '',
        patient_id: '',
        _method: 'PUT',
        has_diabetes: 0,
        has_high_blood_pressure: 0,
        has_heart_disease: 0,
        is_smoker: 0,
      },
      patientCardTypeData: {
        id: '',
        type: '',
      },
      patientCardData: {},
      patientTest: {},
      patientTestForm: {
        patient_card_id: '',
        tests: [],
        _method: 'PUT',
      },
      typeList: [
        {
          text: 'Type 1',
          value: '0',
        },
        {
          text: 'Type 2',
          value: '1',
        },
      ],
      patientRadiology: {},
      patientRadiologyForm: {
        type: '',
        url: '',
        patient_card_id: '',
        radiology_id: '',
        _method: 'PUT',
      },
      patientRoom: {
        room: {},
        day: 1,
      },
      isPatientDischarged: false,
      // is_active: this.$route.params.is_active == true ,
      is_active: false,
      invoices: [],
      currentInvoiceForPrint: null,
      patientDataForPrint: null,
      incubatorNameForPrint: null,
      NICUInvoiceConfig: {
        id: 'NICUInvoice',
      },
      OutClinicInvoiceConfig: {
        id: 'OutClinicInvoice',
      },
      EmergencyInvoiceConfig: {
        id: 'EmergencyInvoice',
      },
      TestInvoiceConfig: {
        id: 'TestInvoice',
      },
      RefundInvoiceConfig: {
        id: 'RefundInvoice',
      },
      SurgeryInsuranceInvoiceConfig: {
        id: 'SurgeryInsuranceInvoice',
      },
      printLoading: false,
      // Surgery Print Data
      patientSurgeries: [],
      selectedSurgeryForPrint: null,
      agreementSurgeryName: '',
      selectedAgreementSurgery: null,
      availableSurgeriesOptions: [],
      // Patient Account Statement
      showPatientAccountStatement: false,
      pendingInvoicesData: [],
      pendingInvoicesTotal: 0,
    }
  },

  computed: {
    permissions() {
      return this.$store.state.auth.permissions || []
    },
    paddedPatientNo() {
      const patientNo = this.patientCardData.patient.patient_no.toString()
      const paddedNo = patientNo.padStart(7, '   ')
      return paddedNo.split('').reverse()
    },
    roomName() {
      const hasroom = this.patientCardData
        && this.patientCardData.patient_room
        && this.patientCardData.patient_room.find(x => !x.out_room_date)
      return hasroom && hasroom.room ? hasroom.room.name : ''
    },
    labTestListFiltered() {
      const uniqueMap = new Map()
      this.labCreate.testsList.forEach(test => {
        const id = test.test_id || test.id
        if (id) {
          uniqueMap.set(id, test)
        }
      })
      return Array.from(uniqueMap.values())
    },
    labTotalPrice() {
      return this.labTestListFiltered.reduce(
        (sum, test) => sum + Number(test.price || 0),
        0,
      )
    },
    canSubmitLab() {
      return this.labTestListFiltered.length > 0 && this.is_active
    },
    canSubmitDrug() {
      return (
        this.drugCreate.source_of_drug
        && ((this.drugCreate.source_of_drug === 'external'
          && this.drugCreate.item_name)
          || (this.drugCreate.source_of_drug !== 'external'
            && this.drugCreate.item_id))
        && this.drugCreate.number_of_doses
        && this.drugCreate.duration_between_doses
        && this.is_active
      )
    },
    canSubmitRadiology() {
      return this.radiologyCreate.radiology_id && this.is_active
    },
    canSubmitConsultation() {
      return (
        this.consultationCreate.doctor_id
        && this.consultationCreate.doctor_price
        && this.is_active
      )
    },
  },
  watch: {
    'labCreate.singleTests': {
      handler(newVal, oldVal) {
        if (!oldVal) return
        if (newVal.length < oldVal.length) {
          const newIds = newVal.map(item => item.test_id || item.id)
          const removedItems = oldVal.filter(
            item => !newIds.includes(item.test_id || item.id),
          )
          removedItems.forEach(removedItem => {
            this.labCreate.testsList = this.labCreate.testsList.filter(
              test => test.test_id !== (removedItem.test_id || removedItem.id),
            )
          })
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.getPatientCard()
  },

  methods: {
    labTestSerializer(val) {
      return {
        name: val.name,
        test_id: val.id,
        price: val.price,
      }
    },
    formatPrice(price) {
      return price ? `${Number(price).toLocaleString()} IQD` : '0 IQD'
    },
    clearAllTests() {
      this.labCreate.testsList = []
      this.labCreate.singleTests = []
      this.labCreate.group = null
      this.labCreate.sampleId = ''
      this.labCreate.sampleDate = new Date().toISOString().slice(0, 10)
    },
    addTestsToList(e) {
      if (!e || !e.length) return
      const newTestsList = [...this.labCreate.testsList]
      const existingIds = new Set()
      newTestsList.forEach(test => {
        const id = test.test_id || test.id
        if (id) existingIds.add(id)
      })
      const testsToAdd = []
      e.forEach(newTest => {
        const testId = newTest.test_id || newTest.id
        if (testId && !existingIds.has(testId)) {
          const test = {
            test_id: testId,
            name: newTest.name,
            price: newTest.price || 0,
          }
          testsToAdd.push(test)
          existingIds.add(testId)
        }
      })
      if (testsToAdd.length > 0) {
        this.labCreate.testsList = [...newTestsList, ...testsToAdd]
      }
    },
    async selectGroup(e) {
      try {
        if (this.labCreate.lastSelectedGroupId !== null) {
          this.labCreate.testsList = this.labCreate.testsList.filter(
            test => test.group_id !== this.labCreate.lastSelectedGroupId,
          )
        }
        this.labCreate.lastSelectedGroupId = e
        await this.getPatient(`/testGroup?filter[group_id]=${e}&include=test`)
        const groupTests = this.all_data?.data || []
        if (groupTests.length === 0) {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'No tests found in this group',
              variant: 'warning',
            },
          })
        } else {
          const mappedTests = groupTests.map(test => ({
            group_id: e,
            price: test.test.price,
            test_id: test.test.id,
            name: test.test.name,
          }))
          const existingTestIds = new Set(
            this.labCreate.testsList.map(test => test.test_id),
          )
          const newGroupTests = mappedTests.filter(
            newTest => !existingTestIds.has(newTest.test_id),
          )
          if (newGroupTests.length > 0) {
            this.labCreate.testsList = [
              ...this.labCreate.testsList,
              ...newGroupTests,
            ]
          }
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Error fetching test group',
            variant: 'danger',
          },
        })
      }
    },
    async submitLab() {
      if (this.labTestListFiltered.length === 0) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Please select at least one test',
            variant: 'warning',
          },
        })
        return
      }
      try {
        const finalData = {
          patient_card_id: this.getNestedProperty(this.patientCardData, 'id'),
          tests: this.labTestListFiltered.map(test => {
            if (test.group_id) {
              delete test.group_id
            }
            return test
          }),
          sample_id: this.labCreate.sampleId,
        }
        if (this.labCreate.sampleDate) {
          finalData.date = this.labCreate.sampleDate
        }
        await this.$store.dispatch('create', {
          form: finalData,
          path: '/patientCardTest',
        })
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Tests added successfully',
            variant: 'success',
          },
        })
        this.clearAllTests()
        this.$bvModal.hide('modal-add-lab-test')
        // Refresh the lab test component to show new data
        if (
          this.$refs.patientCardTest
          && this.$refs.patientCardTest.getPatientTestGroupList
        ) {
          this.$refs.patientCardTest.getPatientTestGroupList()
        }
      } catch (error) {
        if (error.response?.status === 400) {
          const errors = error.response.data
          for (const item in errors) {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Validation Error',
                variant: 'danger',
                text: errors[item][0],
              },
            })
          }
        } else {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Error adding tests',
              variant: 'danger',
            },
          })
        }
      }
    },
    handleDrugSourceChange(value) {
      this.drugCreate.item_name = ''
      this.drugCreate.item_id = null
      this.drugCreate.drug_scientific_name_id = null
    },
    formatDate(dateString) {
      const date = new Date(dateString)
      if (!date || isNaN(date)) {
        return ''
      }
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:00`
    },
    async submitDrug() {
      let count = 0
      if (!this.drugCreate.source_of_drug) {
        count++
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Validation Error',
            variant: 'danger',
            text: 'The source of drug field is required',
          },
        })
      }
      if (this.drugCreate.source_of_drug === 'external') {
        if (!this.drugCreate.item_name) {
          count++
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Validation Error',
              variant: 'danger',
              text: 'The item name field is required',
            },
          })
        }
      } else {
        if (!this.drugCreate.item_id) {
          count++
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Validation Error',
              variant: 'danger',
              text: 'The item field is required',
            },
          })
        }
        if (!this.drugCreate.number_of_doses) {
          count++
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Validation Error',
              variant: 'danger',
              text: 'The number of doses field is required',
            },
          })
        }
        if (!this.drugCreate.duration_between_doses) {
          count++
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Validation Error',
              variant: 'danger',
              text: 'The duration between doses field is required',
            },
          })
        }
      }
      if (count > 0) {
        return false
      }
      const payload = {
        item_id:
          this.drugCreate.source_of_drug === 'external'
            ? null
            : this.drugCreate.item_id,
        item_name:
          this.drugCreate.source_of_drug === 'external'
            ? this.drugCreate.item_name
            : '',
        number_of_doses: this.drugCreate.number_of_doses,
        duration_between_doses: this.drugCreate.duration_between_doses,
        source_of_drug: this.drugCreate.source_of_drug,
        type: this.drugCreate.type,
        dose: this.drugCreate.dose,
        start_time: this.formatDate(this.drugCreate.start_time),
        description: this.drugCreate.description,
        patient_card_id: this.getNestedProperty(this.patientCardData, 'id'),
      }
      if (
        this.drugCreate.source_of_drug === 'pharmacy'
        && this.drugCreate.drug_scientific_name_id
      ) {
        // Note: You may need to adjust this based on your API requirements
      }
      this.params.form = payload
      this.params.path = '/patientCardPrescriptions'
      try {
        await this.$store.dispatch('create', this.params)
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: { title: this.$t('common.success'), variant: 'success' },
        })
        this.drugCreate = {
          item_id: null,
          item_name: '',
          number_of_doses: '',
          duration_between_doses: '',
          source_of_drug: '',
          type: '',
          dose: '',
          start_time: new Date().toISOString(),
          description: '',
          drug_scientific_name_id: null,
        }
        this.$bvModal.hide('modal-add-drug')
        // Refresh the drug component
        if (
          this.$refs.patientDrug
          && this.$refs.patientDrug.getPatientDrugsList
        ) {
          this.$refs.patientDrug.getPatientDrugsList()
        }
      } catch (error) {
        if (error.response && error.response.status === 400) {
          for (const item in error.response.data) {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'validation error',
                variant: 'danger',
                text: error.response.data[item][0],
              },
            })
          }
        }
      }
    },
    async submitRadiology() {
      const payload = {
        type: '1',
        url: this.radiologyCreate.url,
        patient_card_id: this.getNestedProperty(this.patientCardData, 'id'),
        radiology_id: this.radiologyCreate.radiology_id,
      }
      this.params.form = payload
      this.params.path = '/patientCardRadiology'
      try {
        await this.$store.dispatch('create', this.params)
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: { title: this.$t('common.success'), variant: 'success' },
        })
        this.radiologyCreate = { radiology_id: null, type: '1', url: '' }
        this.$bvModal.hide('modal-add-radiology')
        // Refresh the radiology component
        if (
          this.$refs.patientCardRadiology
          && this.$refs.patientCardRadiology.getPatientsRadiologies
        ) {
          this.$refs.patientCardRadiology.getPatientsRadiologies()
        }
      } catch (error) {
        if (error.response && error.response.status === 400) {
          for (const item in error.response.data) {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'validation error',
                variant: 'danger',
                text: error.response.data[item][0],
              },
            })
          }
        }
      }
    },
    async submitConsultation() {
      const payload = {
        patient_card_id: this.getNestedProperty(this.patientCardData, 'id'),
        doctor_id: this.consultationCreate.doctor_id,
        doctor_price: this.consultationCreate.doctor_price,
      }
      this.params.form = payload
      this.params.path = '/consultation'
      try {
        await this.$store.dispatch('create', this.params)
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: { title: this.$t('common.success'), variant: 'success' },
        })
        this.consultationCreate = {
          doctor_id: null,
          doctor_price: '',
        }
        this.$bvModal.hide('modal-add-consultation')
        // Refresh invoices after creating consultation
        await this.fetchInvoices()
      } catch (error) {
        if (error.response && error.response.status === 400) {
          for (const item in error.response.data) {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'validation error',
                variant: 'danger',
                text: error.response.data[item][0],
              },
            })
          }
        } else {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: this.$t('common.error'),
              variant: 'danger',
              text: this.$t('common.error-occurred'),
            },
          })
        }
      }
    },
    show(item) {
      // Bind all patient card data to edit form
      this.EditForm.id = item.id
      this.EditForm.patient_id = item.patient_id

      // Contact information
      this.EditForm.full_companion_name = item.full_companion_name || ''
      this.EditForm.companion_phone = item.companion_phone || ''
      this.EditForm.next_of_kin_name = item.next_of_kin_name || ''
      this.EditForm.next_of_kin_phone_number = item.next_of_kin_phone_number || ''

      // Clinical information
      this.EditForm.patient_case = item.patient_case || ''
      this.EditForm.diagnosis = item.diagnosis || ''
      this.EditForm.investigation = item.investigation || ''
      this.EditForm.examination = item.examination || ''
      this.EditForm.treatment = item.treatment || ''
      this.EditForm.allergy = item.allergy || ''

      // Physical measurements
      this.EditForm.weight = item.weight || ''
      this.EditForm.height = item.height || ''

      // Medical conditions (convert to boolean)
      this.EditForm.is_smoker = item.is_smoker === 1 || item.is_smoker === true
      this.EditForm.has_diabetes = item.has_diabetes === 1 || item.has_diabetes === true
      this.EditForm.has_heart_disease = item.has_heart_disease === 1 || item.has_heart_disease === true
      this.EditForm.has_high_blood_pressure = item.has_high_blood_pressure === 1
        || item.has_high_blood_pressure === true

      this.EditForm._method = 'PUT'
      this.$bvModal.show('modal-edit-patient-card')
    },
    addNewRoomToPatient() {
      const data = {
        patient_card_id: this.patientCardData.id,
        room_id: this.patientRoom.room.id,
        price: this.patientRoom.room.price || 1,
        days: this.patientRoom.day,
      };
      (this.params.form = data),
      (this.params.path = '/patientRoom/'),
      this.$store
        .dispatch('create', this.params)
        .then(response => {
          this.getPatientCard()
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Patient Exit room',
              variant: 'success',
            },
          })
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Add room field',
              variant: 'danger',
            },
          })
        })
    },
    patientExitRoom() {
      const activeRoom = this.patientCardData.patient_room.find(
        x => !x.out_room_date,
      );
      (this.params.form = {}),
      (this.params.path = `/out-patient-from-room/${activeRoom.id}`),
      this.$store
        .dispatch('put', this.params)
        .then(response => {
          this.getPatientCard()
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Patient Exit room',
              variant: 'success',
            },
          })
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Patient Exit room field',
              variant: 'danger',
            },
          })
        })
    },
    hasActiveRoom() {
      const hasroom = this.patientCardData
        && this.patientCardData.patient_room
        && this.patientCardData.patient_room.find(x => !x.out_room_date)
      return !!hasroom
    },

    showExitRoomModel() {
      this.$bvModal.show('modal-exit-room')
    },
    showAddRoomModel() {
      this.$bvModal.show('modal-add-to-room')
    },
    formatDateOnly(date) {
      const d = new Date(date)
      let month = `${d.getMonth() + 1}`
      let day = `${d.getDate()}`
      const year = d.getFullYear()

      if (month.length < 2) month = `0${month}`
      if (day.length < 2) day = `0${day}`
      return [year, month, day].join('-')
    },
    printInpatientForm() {
      this.$refs.currentPatientPdf.generatePdf()
    },

    showCardTypeChange(item) {
      this.patientCardTypeData.type = item.type
      this.patientCardTypeData.id = item.id
      this.$bvModal.show('modal-change-patient-card-type')
    },

    ChangePatientCardType() {
      (this.params.form = this.patientCardTypeData),
      (this.params.path = `/change-card-type/patientCard/${this.patientCardTypeData.id}`),
      this.$store
        .dispatch('put', this.params)
        .then(response => {
          this.getPatientCard()
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Patient Card Edited',
              variant: 'success',
            },
          })
        })
        .catch(error => {
          if (error.response.status === 400) {
            for (const item in error.response.data) {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'validation error',
                  variant: 'danger',
                  text: error.response.data[item][0],
                },
              })
            }
          }
        })
    },

    EditPatientCard() {
      (this.params.form = this.EditForm),
      (this.params.path = `/patientCard/${this.EditForm.id}`),
      this.$store
        .dispatch('update', this.params)
        .then(response => {
          this.getPatientCard()
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Patient Card Edited',
              variant: 'success',
            },
          })
        })
        .catch(error => {
          if (error.response.status === 400) {
            for (const item in error.response.data) {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'validation error',
                  variant: 'danger',
                  text: error.response.data[item][0],
                },
              })
            }
          }
        })
    },

    async getPatientCard() {
      this.loading = true

      // Get route parameters
      const patientId = this.$route.params.id
      const cardId = this.$route.params.card_id

      try {
        // Patient is active, get the specific card
        const response = await this.getPatient(
          `patientCard/${cardId}?include=patient,doctors,surgeries,patientRoom`,
        )
        this.isPatientDischarged = !this.all_data.is_active
        this.is_active = this.all_data.is_active
      } catch (error) {
        console.error('Error fetching patient card:', error)
        // Display error toast notification
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: this.$t('common.error'),
            variant: 'danger',
            text: this.$t('common.error-fetching-data'),
            icon: 'XIcon',
          },
        })
        // Fallback: try to get patient cards by patient ID
      }

      this.loading = false
      for (const item in this.all_data) {
        if (this.all_data[item] == null) this.all_data[item] = ''
      }
      this.patientCardData = this.all_data

      // Fetch invoices for this patient card
      await this.fetchInvoices()

      // Fetch patient surgeries if card type is IN
      if (this.patientCardData.type === 'IN') {
        await this.getPatientSurgeries()
      }
    },

    // Invoice methods
    async fetchInvoices() {
      if (!this.patientCardData.id) return

      try {
        const url = `/invoices?filter[patient_card_id]=${this.patientCardData.id}&include=patientCard&sort=-id`
        await this.getList(url)
        this.invoices = Array.isArray(this.all_data?.data)
          ? this.all_data.data
          : []
      } catch (error) {
        console.error('Error fetching invoices:', error)
        this.invoices = []
      }
    },

    getInvoiceStatusVariant(status) {
      const map = {
        paid: 'success',
        pending: 'warning',
        cancelled: 'danger',
        partial: 'info',
        approved: 'success',
        printed: 'info',
      }
      return map[status] || 'secondary'
    },

    formatInvoiceType(type) {
      // Format invoice type to be more readable
      return type ? type.replace(/_/g, ' ').toUpperCase() : ''
    },
    getInvoiceTypeName(type) {
      const typeMap = {
        invoice_out_clinic: 'cashiers.invoice-type-out-clinic',
        invoice_nicu: 'cashiers.invoice-type-nicu',
        invoice_patient_card_test: 'cashiers.invoice-type-patient-card-test',
        refund: 'cashiers.invoice-type-refund',
        invoice_insurance_surgery: 'cashiers.invoice-type-insurance-surgery',
        invoice_emergency: 'cashiers.invoice-type-emergency',
      }
      const translationKey = typeMap[type]
      return translationKey ? this.$t(translationKey) : type
    },

    showInvoicePrint(invoice) {
      if (this.printLoading) return
      this.currentInvoiceForPrint = invoice
      this.$bvModal.show(`modal-confirm-print-${invoice.id}`)
    },
    handlePrintOk(bvModalEvt) {
      bvModalEvt.preventDefault()
      this.printInvoice()
    },
    handlePrintHide() {
      this.printLoading = false
    },

    async printInvoice() {
      try {
        this.printLoading = true
        this.loading = true

        let includeString = 'service,surgery,patientCard,doctor,invoiceItems'

        if (this.currentInvoiceForPrint.type === 'invoice_nicu') {
          includeString
            += ',patientCardIncubator,patientCardIncubator.incubator'
        } else if (
          this.currentInvoiceForPrint.type === 'invoice_patient_card_test'
        ) {
          includeString += ',patientCardTest,patientCardTest.test'
        }

        const url = `/invoices?filter[id]=${this.currentInvoiceForPrint.id}&include=${includeString}`
        await this.getList(url)

        if (
          this.all_data
          && this.all_data.data
          && this.all_data.data.length > 0
        ) {
          this.currentInvoiceForPrint = this.all_data.data[0]

          // Set patient data for print
          if (this.currentInvoiceForPrint.patient_card) {
            this.patientDataForPrint = {
              ...this.currentInvoiceForPrint.patient_card,
              patient: this.currentInvoiceForPrint.patient_card.patient
                ? { ...this.currentInvoiceForPrint.patient_card.patient }
                : null,
            }
          } else {
            this.patientDataForPrint = this.patientCardData
          }

          // Get incubator name for NICU invoices
          if (this.currentInvoiceForPrint.type === 'invoice_nicu') {
            const incubator = this.currentInvoiceForPrint.patient_card_incubator
            this.incubatorNameForPrint = incubator && incubator.incubator
              ? incubator.incubator.name
              : 'N/A'
          }

          await this.$nextTick()

          setTimeout(() => {
            this.triggerPrint()
            this.changeStatusToPrintedInvoice()
            this.$bvModal.hide(
              `modal-confirm-print-${this.currentInvoiceForPrint.id}`,
            )
          }, 100)
        }
      } catch (error) {
        console.error('Failed to print invoice:', error)
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: this.$t('common.error'),
            variant: 'danger',
            text: this.$t('common.error-occurred'),
          },
        })
      } finally {
        this.loading = false
        this.printLoading = false
      }
    },
    triggerPrint() {
      const refName = this.getPrintRefName()
      if (refName && this.$refs[refName]) {
        this.$refs[refName].click()
      }
    },
    getPrintRefName() {
      if (!this.currentInvoiceForPrint) return null
      const typeMap = {
        invoice_nicu: 'NICUInvoiceRef',
        invoice_out_clinic: 'OutClinicInvoiceRef',
        invoice_emergency: 'EmergencyInvoiceRef',
        invoice_patient_card_test: 'TestInvoiceRef',
        refund: 'RefundInvoiceRef',
        invoice_insurance_surgery: 'SurgeryInsuranceInvoiceRef',
      }
      return typeMap[this.currentInvoiceForPrint.type]
    },
    getPatientDataForTestInvoice() {
      // TestInvoice expects patientData to be the patient object directly
      if (
        this.currentInvoiceForPrint
        && this.currentInvoiceForPrint.patient_card
        && this.currentInvoiceForPrint.patient_card.patient
      ) {
        return { ...this.currentInvoiceForPrint.patient_card.patient }
      }
      return this.patientCardData?.patient || {}
    },

    changeStatusToPrintedInvoice() {
      const params = {
        form: { status: 'printed' },
        path: `/invoices/${this.currentInvoiceForPrint.id}/changeStatus`,
      }
      this.$store
        .dispatch('put', params)
        .then(response => {
          this.fetchInvoices()
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: this.$t('common.success'),
              variant: 'success',
              text: response.data.message,
            },
          })
        })
        .catch(error => {
          if (error.response && error.response.status === 400) {
            for (const item in error.response.data) {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'validation error',
                  variant: 'danger',
                  text: error.response.data[item][0],
                },
              })
            }
          }
        })
    },

    // Surgery Print Methods
    async getPatientSurgeries() {
      if (!this.patientCardData || !this.patientCardData.id) return

      try {
        await this.getList(
          `patient-surgery?filter[patient_card_id]=${this.patientCardData.id}&include=surgery,patientCard,doctors&sort=-id`,
        )
        this.patientSurgeries = Array.isArray(this.all_data?.data)
          ? this.all_data.data
          : []

        // Build available surgeries options for agreement modal
        this.availableSurgeriesOptions = this.patientSurgeries.map(
          surgery => ({
            id: surgery.id,
            title: surgery.surgery ? surgery.surgery.title : '',
          }),
        )
      } catch (error) {
        console.error('Error fetching patient surgeries:', error)
        this.patientSurgeries = []
      }
    },

    async printOperativeNotes() {
      if (this.patientSurgeries.length === 0) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Error',
            variant: 'warning',
            text: 'No surgeries found for this patient',
          },
        })
        return
      }

      // Fetch full surgery data with all includes
      const surgeryId = this.patientSurgeries[0].id
      try {
        await this.getList(
          `patient-surgery/${surgeryId}?include=doctorAssist,surgeryStaff,patientCard,doctors`,
        )
        this.selectedSurgeryForPrint = this.all_data
        console.log(
          this.selectedSurgeryForPrint,
          'this.selectedSurgeryForPrint',
        )

        this.$nextTick(() => {
          if (this.$refs.operativeNotesPrint) {
            this.$refs.operativeNotesPrint.print()
          }
        })
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Error',
            variant: 'danger',
            text: 'Failed to load surgery data',
          },
        })
      }
    },

    async openAgreementPrintModal() {
      if (this.patientSurgeries.length === 0) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Error',
            variant: 'warning',
            text: 'No surgeries found for this patient',
          },
        })
        return
      }

      // Load available surgeries if not already loaded
      if (this.availableSurgeriesOptions.length === 0) {
        await this.getPatientSurgeries()
      }

      // Fetch full surgery data with all includes for the first surgery
      const surgeryId = this.patientSurgeries[0].id
      try {
        await this.getList(
          `patient-surgery/${surgeryId}?include=doctorAssist,surgeryStaff,patientCard,doctors`,
        )
        this.selectedSurgeryForPrint = this.all_data

        // Set default surgery name from first surgery if available
        if (this.selectedSurgeryForPrint.surgery) {
          this.agreementSurgeryName = this.selectedSurgeryForPrint.surgery.title
          const defaultSurgery = this.availableSurgeriesOptions.find(
            s => s.title === this.selectedSurgeryForPrint.surgery.title,
          )
          this.selectedAgreementSurgery = defaultSurgery
            ? defaultSurgery.title
            : null
        } else {
          this.agreementSurgeryName = ''
          this.selectedAgreementSurgery = null
        }
      } catch (error) {
        console.error('Error loading surgery data:', error)
        // Still show modal with basic data
        if (this.patientSurgeries[0].surgery) {
          this.agreementSurgeryName = this.patientSurgeries[0].surgery.title
        }
        this.selectedSurgeryForPrint = this.patientSurgeries[0]
      }

      this.$bvModal.show('modal-agreement-print')
    },

    async generateAgreement() {
      // If a different surgery is selected from dropdown, fetch its data
      if (this.selectedAgreementSurgery) {
        const selectedSurgery = this.availableSurgeriesOptions.find(
          s => s.title === this.selectedAgreementSurgery,
        )
        if (selectedSurgery && selectedSurgery.id) {
          try {
            await this.getList(
              `patient-surgery/${selectedSurgery.id}?include=doctorAssist,surgeryStaff,patientCard,doctors`,
            )
            this.selectedSurgeryForPrint = this.all_data
          } catch (error) {
            console.error('Error loading selected surgery data:', error)
          }
        }
      }

      if (this.$refs.agreementPrint && this.selectedSurgeryForPrint) {
        this.$refs.agreementPrint.print(this.agreementSurgeryName)
      }
      this.$bvModal.hide('modal-agreement-print')
    },

    async printDischargeAgainstAdvice() {
      if (this.patientSurgeries.length === 0) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Error',
            variant: 'warning',
            text: 'No surgeries found for this patient',
          },
        })
        return
      }

      // Fetch full surgery data with all includes
      const surgeryId = this.patientSurgeries[0].id
      try {
        await this.getList(
          `patient-surgery/${surgeryId}?include=doctorAssist,surgeryStaff,patientCard,doctors`,
        )
        this.selectedSurgeryForPrint = this.all_data

        this.$nextTick(() => {
          if (this.$refs.dischargeAgainstAdvicePrint) {
            this.$refs.dischargeAgainstAdvicePrint.print()
          }
        })
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Error',
            variant: 'danger',
            text: 'Failed to load surgery data',
          },
        })
      }
    },

    // NICU Print Methods
    printBirthCertificateCommitment() {
      this.$nextTick(() => {
        if (this.$refs.birthCertificateCommitmentPrintRef) {
          this.$refs.birthCertificateCommitmentPrintRef.print()
        }
      })
    },

    printNICUDischargeAgainstAdvice() {
      this.$nextTick(() => {
        if (this.$refs.nicuDischargeAgainstAdvicePrintRef) {
          this.$refs.nicuDischargeAgainstAdvicePrintRef.print()
        }
      })
    },

    // Unified Patient Account Statement (paid + unpaid in one print)
    async printPatientAccountStatement() {
      try {
        this.showPatientAccountStatement = false
        await this.$nextTick()

        const url = `/invoices?filter[patient_card_id]=${this.patientCardData.id}&take=1000&include=service,surgery,patientCard&sort=-id`
        await this.getList(url)

        this.pendingInvoicesData = Array.isArray(this.all_data?.data)
          ? this.all_data.data
          : []

        // Grand total of all invoices
        this.pendingInvoicesTotal = this.pendingInvoicesData.reduce(
          (sum, invoice) => sum + parseFloat(invoice.amount || 0),
          0,
        )

        // Show the component
        this.showPatientAccountStatement = true

        // Wait for component to render, then trigger print
        await this.$nextTick()
        setTimeout(() => {
          const patientAccountStatementRef = this.$refs.patientAccountStatement
          if (
            patientAccountStatementRef
            && patientAccountStatementRef.generatePdf
          ) {
            patientAccountStatementRef.generatePdf()
          }
        }, 500)
      } catch (error) {
        console.error('Error fetching invoices for account statement:', error)
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: this.$t('common.error'),
            variant: 'danger',
            text: this.$t('common.error-fetching-data'),
          },
        })
      }
    },
  },
}
</script>

<style scoped>
.mb-md-0 {
  margin-top: 8px;
}

.start-box {
  display: flex;
  flex-direction: column;
  align-items: start;
  margin: 0 1rem;
  position: absolute;
  right: 1%;
  top: -13.5%;
}

table {
  width: 94%;
  border: 1px solid;
  font-size: 11px;
}

.no-border {
  border: 0;
}

.square-dark {
  background-color: rgba(0, 0, 0, 0.2);
}

tr,
th,
td {
  border: 1px solid;
  width: 10px;
  height: 10px;
  text-align: center;
}

.font-modify {
  letter-spacing: normal !important;
}

.pdf-table {
  page-break-inside: avoid;
}

.square {
  width: 30px;
  /* Smaller width for squares */
  height: 30px;
  /* Smaller height for squares */
  background-color: #000;
  /* Color of the square */
  display: inline-block;
  /* Allows us to set width and height */
}

.centered-text {
  text-align: center;
  border: 2px solid #000;
  /* Border for the cell */
}

#table-above {
  border-collapse: collapse;
  /* Removes space between borders */
  font-size: 12px;
  /* Smaller font size for the entire table */
}

@media print {
  @page {
  }

  .pdf-table {
    page-break-before: avoid;
    page-break-inside: avoid;
  }
}

.pdf-table:first-child {
  margin-top: 1em;
  /* Adjust the value as needed */
  page-break-inside: avoid;
}
.font-modify {
  letter-spacing: normal !important;
}

/* Modern Patient Card Styles */
.patient-card-modern {
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.card-header-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

.card-header-actions > div:first-child {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
}

.back-btn {
  min-width: auto;
  white-space: nowrap;
  flex-shrink: 0;
}

.card-title {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
  flex: 1;
}

.card-title i {
  font-size: 1.8rem;
}

.action-buttons {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.action-buttons .btn {
  display: flex;
  align-items: center;
  gap: 6px;
}

.patient-identity {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 15px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  border-radius: 8px;
}

.identity-info {
  flex: 1;
}

.patient-name {
  font-size: 1.5rem;
  color: #2c3e50;
  font-weight: 700;
}

.divider {
  margin: 20px 0;
  border-color: #e0e6ed;
}

.info-section {
  margin-bottom: 20px;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 1.1rem;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 15px;
}

.section-title i {
  font-size: 1.3rem;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 15px;
}

.info-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 6px;
  border-left: 3px solid #17a2b8;
}

.info-item i {
  font-size: 1.2rem;
  margin-top: 2px;
}

.info-item .label {
  display: block;
  font-size: 0.75rem;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 2px;
}

.info-item .value {
  display: block;
  font-size: 1rem;
  color: #2c3e50;
}

.medical-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 12px;
}

.medical-badge {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 15px 10px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 2px solid #e0e6ed;
  text-align: center;
  transition: all 0.3s ease;
}

.medical-badge:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.medical-badge i {
  font-size: 1.8rem;
  color: #6c757d;
  margin-bottom: 8px;
}

.medical-badge.has-condition {
  border-width: 2px;
}

.medical-badge.has-condition.danger {
  background: #fff5f5;
  border-color: #dc3545;
}

.medical-badge.has-condition.danger i {
  color: #dc3545;
}

.medical-badge.has-condition.warning {
  background: #fffbf0;
  border-color: #ffc107;
}

.medical-badge.has-condition.warning i {
  color: #ffc107;
}

.medical-badge.has-condition.secondary {
  background: #f8f9fa;
  border-color: #6c757d;
}

.medical-badge.has-condition.secondary i {
  color: #6c757d;
}

.condition-label {
  display: block;
  font-size: 0.7rem;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
}

.condition-value {
  display: block;
  font-size: 0.95rem;
  color: #2c3e50;
  font-weight: 600;
}

.clinical-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 15px;
}

.clinical-item {
  padding: 15px;
  background: #f8f9fa;
  border-radius: 6px;
  border-left: 4px solid #007bff;
}

.clinical-item.full-width {
  grid-column: 1 / -1;
}

.clinical-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.clinical-header i {
  font-size: 1.1rem;
}

.clinical-header span {
  font-size: 0.85rem;
  font-weight: 600;
  color: #495057;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.clinical-text {
  margin: 0;
  padding-left: 28px;
  color: #2c3e50;
  font-size: 0.95rem;
  line-height: 1.5;
}

.timeline-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 15px;
}

.timeline-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 6px;
}

.timeline-item i {
  font-size: 1.3rem;
  margin-top: 2px;
}

.timeline-item .label {
  display: block;
  font-size: 0.75rem;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 2px;
}

.timeline-item .value {
  display: block;
  font-size: 0.95rem;
  color: #2c3e50;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .card-header-actions {
    flex-direction: column;
    align-items: flex-start;
  }

  .card-header-actions > div:first-child {
    width: 100%;
    flex-wrap: wrap;
  }

  .back-btn {
    margin-bottom: 8px;
  }

  .action-buttons {
    width: 100%;
    margin-top: 12px;
  }

  .action-buttons .btn {
    flex: 1;
    min-width: 120px;
  }

  .info-grid,
  .medical-grid,
  .clinical-grid,
  .timeline-grid {
    grid-template-columns: 1fr;
  }

  .patient-identity {
    flex-direction: column;
    text-align: center;
  }
}

/* Lab Test Modal Styles */
.selected-tests-section {
  margin-bottom: 1.5rem;
}

.selected-tests-container {
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  padding: 1rem;
  background-color: #f8f9fa;
  min-height: 200px;
  max-height: 400px;
  overflow-y: auto;
}

.selected-tests-container .table td {
  vertical-align: middle;
  padding: 0.5rem;
}

.selected-tests-container .table thead th {
  font-weight: 600;
  text-transform: uppercase;
  font-size: 0.8rem;
  letter-spacing: 0.5px;
}

/* Invoices Section */
.invoices-section {
  background: white;
  border-radius: 16px;
  padding: 2rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid #e2e8f0;
  margin-bottom: 2rem;
}

.invoices-section .section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
  gap: 1rem;
}

.invoices-section .section-title {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  color: #667eea;
}

.invoices-section .section-title h3 {
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0;
  color: #0f172a;
}

.invoices-section .count-badge {
  background: #667eea;
  color: white;
  font-size: 0.875rem;
  font-weight: 600;
  padding: 0.25rem 0.625rem;
  border-radius: 12px;
}

.invoices-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1.25rem;
}

.invoice-card {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border: 2px solid #e2e8f0;
  border-radius: 14px;
  padding: 1.25rem;
  transition: all 0.3s;
}

.invoice-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  border-color: #667eea;
}

.invoice-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.invoice-number {
  font-size: 1rem;
  font-weight: 700;
  color: #0f172a;
}

.invoice-status {
  font-size: 0.75rem;
  padding: 0.375rem 0.75rem;
}

.invoice-status-wrapper {
  display: flex;
  align-items: center;
}

.invoice-amount {
  font-size: 1.5rem;
  font-weight: 700;
  color: #22c55e;
  margin-bottom: 0.75rem;
}

.invoice-description {
  font-size: 0.875rem;
  color: #64748b;
  margin-bottom: 0.75rem;
  line-height: 1.5;
}

.invoice-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 0.75rem;
  border-top: 1px dashed #cbd5e1;
  gap: 0.5rem;
}

.invoice-date,
.invoice-type {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  color: #64748b;
}

.invoice-actions {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px dashed #cbd5e1;
  display: flex;
  justify-content: flex-end;
}

.invoice-actions button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.no-invoices {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 2rem;
  color: #94a3b8;
}

.no-invoices i {
  opacity: 0.3;
  margin-bottom: 1rem;
}

.no-invoices p {
  margin: 0;
  font-size: 1rem;
}

.hidden {
  display: none !important;
}

/* Print styles */
@media print {
  .patient-card-modern,
  .action-buttons,
  .invoices-section > .section-header {
    display: none !important;
  }
}

.print-only {
  display: none;
}

@media print {
  .print-only {
    display: block !important;
  }
}
</style>
